<template>
    <div class="map">
      
         <div id="container"></div>
        <!--<img src="../../static/images/contact_map.png" alt="">-->
    </div>
</template>

<script>
export default {
    name: 'Map',
    methods: {
    },
    mounted() {
        var mp = new BMap.Map("container");
        let  point = new BMap.Point(114.424808,23.053059);
        var marker = new BMap.Marker(point);  // 创建标注
        mp.addOverlay(marker);              // 将标注添加到地图中
        mp.centerAndZoom(point, 16);
        var opts = {
            width : 350,     // 信息窗口宽度
            height: 100,     // 信息窗口高度
            title : "广东一匠科技有限公司" , // 信息窗口标题
            enableMessage:true,//设置允许信息窗发送短息
            message:"广东省广州市天河区荷光路137号三楼<br/>13824289487<br/>glb@wsandows.com"
        }
        var infoWindow = new BMap.InfoWindow("广东省广州市天河区荷光路137号三楼<br/>13824289487<br/>glb@wsandows.com", opts);  // 创建信息窗口对象 
        mp.openInfoWindow(infoWindow,point); //开启信息窗口
        mp.enableScrollWheelZoom();
        var canvasLayer = new BMap.CanvasLayer({
            update: update
        });
        function update() {
            var ctx = this.canvas.getContext("2d");
            if (!ctx) {
                return;
            }
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            // var temp = {};
            // ctx.fillStyle = "rgba(50, 50, 255, 0.7)";
            // ctx.beginPath();
            // var data = [
            //     new BMap.Point(114.424808,23.053059),
            //     new BMap.Point(114.424808,23.053059),
            //     new BMap.Point(114.424808,23.053059)
            // ];
            // for (var i = 0, len = data.length; i < len; i++) {
            //     var pixel = mp.pointToPixel(data[i]);
            //     ctx.fillRect(pixel.x, pixel.y, 40, 30);
            // }
        }
        mp.addOverlay(canvasLayer);
    },
}
</script>

<style lang="stylus" scoped>
    #container >>> .BMap_bubble_title 
                        color: red !important
    .map
        width: 100%
        max-width: 1920px
        min-width: 1440px
        margin: 0 auto
        height: 500px
        margin-top: 90px
        #container 
            height: 500px
        
</style>



// WEBPACK FOOTER //
// src/components/pc/ContactMap.vue